import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CheckoutHeader } from "../components/CheckoutHeader";

export const Template = (
    props: Immutable<templates.CheckoutHeaderTemplate>,
): React.JSX.Element => <CheckoutHeader {...props} />;
